
import  sAction  from "sAction";
import DefaultImage from '../../defaultFields/Image/Image';
export default class Image extends DefaultImage {
    

}
